import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PageLayout from "./components/PageLayout"
import Home from './pages/Home';
import Impressum from './pages/Impressum';
import Privacy from './pages/Privacy';
import "./App.css"

function App() {
  return (
    <Router>
      <PageLayout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Privacy />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </PageLayout>
    </Router>
  );
}

export default App;
